import Serializer, {
  type DeserializeArguments,
  type SerializeArguments,
} from './Serializer';
import { isHTMLElementNode } from '../helpers/serializerHelpers';
import React from 'react';
import { isSharedSnippetElement } from '../../types/guards';
import type {
  SharedSnippetInlineElement,
  SharedSnippetElement,
} from '../../types/aha-editor';

class SerializerSharedSnippet extends Serializer {
  static deserialize({
    el,
  }: DeserializeArguments):
    | SharedSnippetElement
    | SharedSnippetInlineElement
    | undefined {
    if (!isHTMLElementNode(el)) return;
    const token = el.dataset?.sharedSnippetToken;
    if (!token) return;

    if (el.tagName.toLowerCase() === 'div') {
      return {
        type: 'shared-snippet',
        children: [
          {
            text: '',
          },
        ],
        sharedSnippet_token: token,
      };
    } else if (el.tagName.toLowerCase() === 'span') {
      return {
        type: 'shared-snippet-inline',
        children: [
          {
            text: '',
          },
        ],
        sharedSnippet_token: token,
      };
    }
  }

  static serialize({ node }: SerializeArguments) {
    if (!isSharedSnippetElement(node)) return;

    if (node.type === 'shared-snippet') {
      return <div data-shared-snippet-token={node.sharedSnippet_token}></div>;
    } else if (node.type === 'shared-snippet-inline') {
      return <span data-shared-snippet-token={node.sharedSnippet_token}></span>;
    }
  }
}

export default SerializerSharedSnippet;
